import React, { useState } from 'react';
import { Reorder } from 'framer-motion';
import { useTimelineStore } from '../store/timelineStore';
import { useVideoStore } from '../store/videoStore';
import ClipItem from './ClipItem';

const TrackList = () => {
  const { 
    tracks, 
    addTrack, 
    deleteTrack, 
    renameTrack, 
    reorderTracks,
    showExport 
  } = useTimelineStore();
  
  const { formatTime } = useVideoStore();
  const [editingTrackId, setEditingTrackId] = useState(null);
  const [newTrackName, setNewTrackName] = useState('');

  // 轨道预览功能
  const handlePlayTrack = (trackId) => {
    const track = tracks.find(t => t.id === trackId);
    if (!track || track.clips.length === 0) {
      alert('轨道为空，无法播放');
      return;
    }

    console.log('播放轨道:', track.name, '片段数量:', track.clips.length);

    // 获取视频文件路径
    const timelineState = useTimelineStore.getState();
    const videoFile = timelineState.videoFile;
    
    if (!videoFile) {
      alert('找不到原始视频文件，请重新加载视频');
      return;
    }

    // 创建预览窗口
    const previewWindow = window.open('', '_blank', 'width=1200,height=800,scrollbars=yes');
    
    if (!previewWindow) {
      alert('无法打开预览窗口，请检查浏览器弹窗设置');
      return;
    }

    // 生成预览窗口的HTML内容
    const previewHTML = `
<!DOCTYPE html>
<html lang="zh-CN">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>轨道预览 - ${track.name}</title>
    <style>
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; background: #1a1a1a; color: #ffffff; }
        .preview-container { max-width: 1200px; margin: 0 auto; padding: 20px; }
        .preview-header { text-align: center; margin-bottom: 30px; padding: 20px; background: linear-gradient(135deg, #2c3e50, #3498db); border-radius: 10px; }
        .track-title { font-size: 28px; font-weight: bold; margin-bottom: 10px; color: ${track.color}; }
        .track-info { font-size: 16px; opacity: 0.9; }
        .video-container { position: relative; margin-bottom: 30px; background: #000; border-radius: 10px; overflow: hidden; box-shadow: 0 10px 30px rgba(0,0,0,0.5); }
        #previewVideo { width: 100%; height: auto; display: block; }
        #previewCanvas { width: 100%; height: auto; display: none; background: #000; }
        .video-overlay { position: absolute; top: 20px; left: 20px; background: rgba(0,0,0,0.8); padding: 10px 15px; border-radius: 5px; font-size: 14px; color: #fff; z-index: 10; }
        .controls { display: flex; justify-content: center; gap: 15px; margin-bottom: 30px; flex-wrap: wrap; }
        .control-btn { padding: 12px 24px; border: none; border-radius: 25px; font-size: 16px; font-weight: 600; cursor: pointer; transition: all 0.3s ease; min-width: 120px; }
        .btn-primary { background: linear-gradient(135deg, #4CAF50, #45a049); color: white; }
        .btn-secondary { background: linear-gradient(135deg, #2196F3, #1976D2); color: white; }
        .btn-danger { background: linear-gradient(135deg, #f44336, #d32f2f); color: white; }
        .btn-warning { background: linear-gradient(135deg, #ff9800, #f57c00); color: white; }
        .control-btn:disabled { opacity: 0.5; cursor: not-allowed; }
        .clips-list { background: #2a2a2a; border-radius: 10px; padding: 20px; margin-bottom: 20px; }
        .clips-list h3 { margin-bottom: 20px; color: ${track.color}; font-size: 20px; text-align: center; }
        .clip-item { display: flex; align-items: center; padding: 15px; margin-bottom: 10px; background: #3a3a3a; border-radius: 8px; border-left: 4px solid ${track.color}; transition: all 0.3s ease; cursor: pointer; }
        .clip-item:hover { background: #4a4a4a; transform: translateX(5px); }
        .clip-item.playing { background: linear-gradient(135deg, ${track.color}20, ${track.color}10); border-left-color: #4CAF50; box-shadow: 0 0 20px ${track.color}30; }
        .clip-item.played { opacity: 0.6; background: #2a2a2a; }
        .clip-index { background: ${track.color}; color: white; width: 30px; height: 30px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-weight: bold; margin-right: 15px; font-size: 14px; }
        .clip-title { flex: 1; font-weight: 600; font-size: 16px; }
        .clip-time { color: #888; margin-right: 15px; font-family: monospace; font-size: 14px; }
        .clip-duration { background: #555; padding: 4px 8px; border-radius: 4px; font-size: 12px; font-family: monospace; }
        .current-clip-info { text-align: center; padding: 15px; background: #333; border-radius: 8px; margin-bottom: 20px; font-size: 18px; font-weight: 600; }
        .progress-info { text-align: center; margin-top: 20px; padding: 15px; background: #2a2a2a; border-radius: 8px; font-size: 14px; color: #ccc; }
        .completion-message { text-align: center; padding: 30px; background: linear-gradient(135deg, #4CAF50, #45a049); border-radius: 10px; margin: 20px 0; font-size: 20px; font-weight: bold; }
    </style>
</head>
<body>
    <div class="preview-container">
        <div class="preview-header">
            <div class="track-title">${track.name}</div>
            <div class="track-info">${track.clips.length} 个片段 | 总时长: ${formatTime(track.clips.reduce((sum, clip) => sum + clip.duration, 0))}</div>
        </div>
        
        <div class="video-container">
            <video id="previewVideo" controls>
                <source src="${videoFile}" type="video/mp4">
                您的浏览器不支持视频播放。
            </video>
            <canvas id="previewCanvas"></canvas>
            <div class="video-overlay" id="videoOverlay">准备播放...</div>
        </div>
        
        <div class="current-clip-info" id="currentClipInfo">点击"开始连续播放"开始播放轨道中的所有片段</div>
        
        <div class="controls">
            <button class="control-btn btn-primary" id="startBtn">开始连续播放</button>
            <button class="control-btn btn-secondary" id="pauseBtn" disabled>暂停</button>
            <button class="control-btn btn-danger" id="stopBtn" disabled>停止</button>
            <button class="control-btn btn-warning" id="prevBtn" disabled>上一个</button>
            <button class="control-btn btn-warning" id="nextBtn" disabled>下一个</button>
            <button class="control-btn btn-secondary" id="loopBtn">循环播放: 关</button>
        </div>
        
        <div class="clips-list">
            <h3>片段列表 (${track.clips.length} 个片段)</h3>
            <div id="clipsList">
                ${track.clips.map((clip, index) => `
                    <div class="clip-item" data-index="${index}">
                        <span class="clip-index">${index + 1}</span>
                        <span class="clip-title">${clip.title}</span>
                        <span class="clip-time">${formatTime(clip.startTime)} - ${formatTime(clip.endTime)}</span>
                        <span class="clip-duration">${formatTime(clip.duration)}</span>
                    </div>
                `).join('')}
            </div>
        </div>
        
        <div class="progress-info" id="progressInfo">准备就绪 - 共 ${track.clips.length} 个片段等待播放</div>
    </div>

    <script>
        const trackData = ${JSON.stringify(track)};
        const clips = trackData.clips;
        
        let currentClipIndex = 0;
        let isPlaying = false;
        let isLooping = false;
        let playbackTimer = null;
        
        const video = document.getElementById('previewVideo');
        const canvas = document.getElementById('previewCanvas');
        const ctx = canvas.getContext('2d');
        const overlay = document.getElementById('videoOverlay');
        const currentClipInfo = document.getElementById('currentClipInfo');
        const progressInfo = document.getElementById('progressInfo');
        
        const startBtn = document.getElementById('startBtn');
        const pauseBtn = document.getElementById('pauseBtn');
        const stopBtn = document.getElementById('stopBtn');
        const prevBtn = document.getElementById('prevBtn');
        const nextBtn = document.getElementById('nextBtn');
        const loopBtn = document.getElementById('loopBtn');
        
        video.addEventListener('loadedmetadata', () => {
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
        });
        
        function playClip(index) {
            if (index < 0 || index >= clips.length) return;
            
            currentClipIndex = index;
            const clip = clips[index];
            
            video.style.display = 'none';
            canvas.style.display = 'block';
            video.controls = false;
            video.style.pointerEvents = 'none';
            video.currentTime = clip.startTime;
            
            video.onseeked = function() {
                video.play();
                isPlaying = true;
                updateUI();
                startCanvasRendering(clip);
                
                clearInterval(playbackTimer);
                playbackTimer = setInterval(() => {
                    if (video.currentTime >= clip.endTime - 0.05) {
                        clearInterval(playbackTimer);
                        video.pause();
                        overlay.textContent = '片段切换中...';
                        overlay.style.background = 'rgba(255, 152, 0, 0.9)';
                        
                        if (currentClipIndex < clips.length - 1) {
                            currentClipIndex++;
                            setTimeout(() => playClip(currentClipIndex), 200);
                        } else {
                            if (isLooping) {
                                currentClipIndex = 0;
                                setTimeout(() => playClip(currentClipIndex), 200);
                            } else {
                                stopPlayback();
                                showCompletionMessage();
                            }
                        }
                    }
                }, 50);
            };
        }
        
        function startCanvasRendering(clip) {
            function render() {
                if (!isPlaying || video.paused) return;
                if (video.currentTime < clip.startTime || video.currentTime >= clip.endTime) return;
                
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                
                ctx.fillStyle = 'rgba(0, 0, 0, 0.7)';
                ctx.fillRect(20, 20, 300, 40);
                ctx.fillStyle = '#ffffff';
                ctx.font = 'bold 16px Arial';
                ctx.fillText(clip.title, 30, 45);
                
                const progress = ((video.currentTime - clip.startTime) / clip.duration * 100).toFixed(1);
                overlay.textContent = \`正在播放: \${clip.title} (\${progress}%)\`;
                overlay.style.background = 'rgba(76, 175, 80, 0.9)';
                
                requestAnimationFrame(render);
            }
            render();
        }
        
        function startPlayback() {
            if (clips.length === 0) {
                alert('轨道中没有片段可播放');
                return;
            }
            currentClipIndex = 0;
            playClip(currentClipIndex);
        }
        
        function pausePlayback() {
            video.pause();
            isPlaying = false;
            clearInterval(playbackTimer);
            updateUI();
        }
        
        function resumePlayback() {
            video.play();
            isPlaying = true;
            const clip = clips[currentClipIndex];
            startCanvasRendering(clip);
            
            playbackTimer = setInterval(() => {
                if (video.currentTime >= clip.endTime - 0.05) {
                    clearInterval(playbackTimer);
                    video.pause();
                    
                    if (currentClipIndex < clips.length - 1) {
                        currentClipIndex++;
                        setTimeout(() => playClip(currentClipIndex), 200);
                    } else {
                        if (isLooping) {
                            currentClipIndex = 0;
                            setTimeout(() => playClip(currentClipIndex), 200);
                        } else {
                            stopPlayback();
                            showCompletionMessage();
                        }
                    }
                }
            }, 50);
            updateUI();
        }
        
        function stopPlayback() {
            video.pause();
            isPlaying = false;
            currentClipIndex = 0;
            clearInterval(playbackTimer);
            
            video.style.display = 'block';
            canvas.style.display = 'none';
            video.controls = true;
            video.style.pointerEvents = 'auto';
            video.onseeked = null;
            
            overlay.textContent = '已停止';
            overlay.style.background = 'rgba(244, 67, 54, 0.9)';
            currentClipInfo.textContent = '已停止 - 点击"开始连续播放"重新开始';
            updateUI();
        }
        
        function prevClip() {
            if (currentClipIndex > 0) {
                currentClipIndex--;
                playClip(currentClipIndex);
            }
        }
        
        function nextClip() {
            if (currentClipIndex < clips.length - 1) {
                currentClipIndex++;
                playClip(currentClipIndex);
            }
        }
        
        function toggleLoop() {
            isLooping = !isLooping;
            loopBtn.textContent = \`循环播放: \${isLooping ? '开' : '关'}\`;
            loopBtn.style.background = isLooping ? 
                'linear-gradient(135deg, #4CAF50, #45a049)' : 
                'linear-gradient(135deg, #2196F3, #1976D2)';
        }
        
        function updateUI() {
            startBtn.disabled = isPlaying;
            pauseBtn.disabled = !isPlaying;
            stopBtn.disabled = !isPlaying && currentClipIndex === 0;
            prevBtn.disabled = !isPlaying || currentClipIndex === 0;
            nextBtn.disabled = !isPlaying || currentClipIndex === clips.length - 1;
            
            const clipItems = document.querySelectorAll('.clip-item');
            clipItems.forEach((item, index) => {
                item.classList.remove('playing', 'played');
                if (index === currentClipIndex && isPlaying) {
                    item.classList.add('playing');
                } else if (index < currentClipIndex) {
                    item.classList.add('played');
                }
            });
            
            if (isPlaying && clips[currentClipIndex]) {
                const clip = clips[currentClipIndex];
                currentClipInfo.textContent = \`正在播放: \${clip.title} (第 \${currentClipIndex + 1}/\${clips.length} 个片段)\`;
            }
            
            const playedCount = currentClipIndex + (isPlaying ? 1 : 0);
            progressInfo.textContent = \`进度: \${playedCount}/\${clips.length} 个片段 | 循环播放: \${isLooping ? '开启' : '关闭'}\`;
        }
        
        function showCompletionMessage() {
            const completionDiv = document.createElement('div');
            completionDiv.className = 'completion-message';
            completionDiv.textContent = \`🎉 轨道"\${trackData.name}"的所有片段播放完毕！\`;
            
            const container = document.querySelector('.preview-container');
            container.insertBefore(completionDiv, container.querySelector('.progress-info'));
            
            setTimeout(() => {
                completionDiv.remove();
            }, 5000);
        }
        
        startBtn.addEventListener('click', startPlayback);
        pauseBtn.addEventListener('click', () => {
            if (isPlaying) {
                pausePlayback();
            } else {
                resumePlayback();
            }
        });
        stopBtn.addEventListener('click', stopPlayback);
        prevBtn.addEventListener('click', prevClip);
        nextBtn.addEventListener('click', nextClip);
        loopBtn.addEventListener('click', toggleLoop);
        
        document.querySelectorAll('.clip-item').forEach((item, index) => {
            item.addEventListener('click', () => {
                if (isPlaying) {
                    currentClipIndex = index;
                    playClip(currentClipIndex);
                }
            });
        });
        
        document.addEventListener('keydown', (e) => {
            switch(e.code) {
                case 'Space':
                    e.preventDefault();
                    if (isPlaying) {
                        pausePlayback();
                    } else if (currentClipIndex >= 0) {
                        resumePlayback();
                    } else {
                        startPlayback();
                    }
                    break;
                case 'ArrowLeft':
                    e.preventDefault();
                    prevClip();
                    break;
                case 'ArrowRight':
                    e.preventDefault();
                    nextClip();
                    break;
                case 'KeyL':
                    e.preventDefault();
                    toggleLoop();
                    break;
                case 'KeyS':
                    e.preventDefault();
                    stopPlayback();
                    break;
            }
        });
        
        updateUI();
    </script>
</body>
</html>`;

    previewWindow.document.write(previewHTML);
    previewWindow.document.close();
    previewWindow.focus();
  };

  // 拖拽处理函数
  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
    const container = e.currentTarget;
    container.style.borderColor = '#007AFF';
    container.style.backgroundColor = 'rgba(0, 122, 255, 0.1)';
  };

  const handleDragLeave = (e) => {
    const container = e.currentTarget;
    container.style.borderColor = 'transparent';
    container.style.backgroundColor = 'transparent';
  };

  const handleDrop = (e, targetTrackId) => {
    e.preventDefault();
    const container = e.currentTarget;
    container.style.borderColor = 'transparent';
    container.style.backgroundColor = 'transparent';
    
    try {
      const dragData = JSON.parse(e.dataTransfer.getData('text/plain'));
      
      // 检查是否是片段拖拽数据
      if (dragData.clipId && dragData.trackId) {
        const { clipId, trackId: sourceTrackId } = dragData;
        
        // 如果是同一个轨道，不执行移动
        if (sourceTrackId === targetTrackId) {
          return;
        }
        
        // 移动片段到目标轨道
        const { moveClipToTrack } = useTimelineStore.getState();
        moveClipToTrack(clipId, sourceTrackId, targetTrackId);
        
        console.log(`片段已从 ${sourceTrackId} 移动到 ${targetTrackId}`);
      }
    } catch (error) {
      console.error('拖拽数据解析失败:', error);
    }
  };

  // 处理轨道重命名
  const handleTrackDoubleClick = (trackId, currentName) => {
    setEditingTrackId(trackId);
    setNewTrackName(currentName);
  };

  const handleTrackRename = (trackId) => {
    if (newTrackName.trim() && newTrackName !== tracks.find(t => t.id === trackId)?.name) {
      renameTrack(trackId, newTrackName.trim());
    }
    setEditingTrackId(null);
    setNewTrackName('');
  };

  const handleTrackRenameKeyPress = (e, trackId) => {
    if (e.key === 'Enter') {
      handleTrackRename(trackId);
    } else if (e.key === 'Escape') {
      setEditingTrackId(null);
      setNewTrackName('');
    }
  };

  // 处理轨道重新排序
  const handleReorder = (newTracks) => {
    const currentOrder = tracks.map(t => t.id);
    const newOrder = newTracks.map(t => t.id);
    
    if (JSON.stringify(currentOrder) !== JSON.stringify(newOrder)) {
      reorderTracks(newTracks);
    }
  };

  // 处理片段重新排序
  const handleClipReorder = (trackId, newClips) => {
    const { reorderClipsInTrack } = useTimelineStore.getState();
    reorderClipsInTrack(trackId, newClips);
  };

  return (
    <div className="track-list">
      <div className="track-list-header">
        <h3>轨道列表</h3>
        <button 
          className="btn-add-track"
          onClick={() => addTrack()}
          title="添加新轨道"
        >
          + 添加轨道
        </button>
      </div>

      <Reorder.Group 
        axis="y" 
        values={tracks} 
        onReorder={handleReorder}
        className="tracks-container"
      >
        {tracks.map((track) => (
          <Reorder.Item 
            key={track.id} 
            value={track}
            className="track-item"
            style={{ cursor: 'default' }}
            whileDrag={{ 
              zIndex: 1000,
              cursor: 'grabbing'
            }}
          >
            <div 
              className="track-header"
              data-drag-handle
              style={{ cursor: 'grab' }}
            >
              <div className="track-drag-handle">
                <div className="drag-dots">
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
              <div className="track-info">
                <div 
                  className="track-color-indicator"
                  style={{ backgroundColor: track.color }}
                />
                {editingTrackId === track.id ? (
                  <input
                    type="text"
                    value={newTrackName}
                    onChange={(e) => setNewTrackName(e.target.value)}
                    onBlur={() => handleTrackRename(track.id)}
                    onKeyPress={(e) => handleTrackRenameKeyPress(e, track.id)}
                    autoFocus
                    className="track-name-input"
                  />
                ) : (
                  <h4 
                    className="track-name"
                    onDoubleClick={() => handleTrackDoubleClick(track.id, track.name)}
                    title="双击重命名"
                  >
                    {track.name}
                  </h4>
                )}
                <div className="track-stats">
                  <span>{track.clips.length} 个片段</span>
                  <span>{Math.round(track.clips.reduce((sum, clip) => sum + clip.duration, 0))}秒</span>
                </div>
              </div>
              <div className="track-controls">
                <button
                  className="btn-play-track"
                  onClick={() => handlePlayTrack(track.id)}
                  disabled={track.clips.length === 0}
                  title="播放轨道"
                >
                  ▶
                </button>
                <button
                  className="btn-export-track"
                  onClick={() => showExport(track.id)}
                  disabled={track.clips.length === 0}
                  title="导出轨道"
                >
                  导出
                </button>
                <button
                  className="btn-delete-track"
                  onClick={() => {
                    if (window.confirm(`确定要删除轨道"${track.name}"吗？`)) {
                      deleteTrack(track.id);
                    }
                  }}
                  title="删除轨道"
                >
                  ×
                </button>
              </div>
            </div>

            <div 
              className="clips-container"
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={(e) => handleDrop(e, track.id)}
              style={{
                minHeight: '60px',
                border: '2px dashed transparent',
                borderRadius: '8px',
                transition: 'all 0.3s ease'
              }}
            >
              {track.clips.length === 0 ? (
                <div className="empty-track-message">
                  拖拽片段到此轨道，或使用快捷键录制片段
                </div>
              ) : (
                <Reorder.Group 
                  axis="x" 
                  values={track.clips} 
                  onReorder={(newClips) => handleClipReorder(track.id, newClips)}
                  className="clips-grid"
                  layoutScroll
                  style={{
                    display: 'flex',
                    gap: '8px',
                    flexWrap: 'nowrap',
                    alignItems: 'center',
                    minHeight: '50px',
                    padding: '4px',
                    justifyContent: 'flex-start',
                    alignContent: 'center'
                  }}
                >
                  {track.clips.map((clip) => (
                    <Reorder.Item 
                      key={clip.id} 
                      value={clip}
                      style={{ cursor: 'grab' }}
                      whileDrag={{ 
                        scale: 1.05, 
                        zIndex: 1000,
                        cursor: 'grabbing',
                        boxShadow: '0 8px 25px rgba(0,0,0,0.3)'
                      }}
                      dragSnapToOrigin={false}
                      dragElastic={0.1}
                      dragMomentum={false}
                      transition={{
                        type: "spring",
                        stiffness: 400,
                        damping: 25
                      }}
                    >
                      <ClipItem
                        clip={clip}
                        trackId={track.id}
                        trackColor={track.color}
                      />
                    </Reorder.Item>
                  ))}
                </Reorder.Group>
              )}
            </div>
          </Reorder.Item>
        ))}
      </Reorder.Group>

      {tracks.length === 0 && (
        <div className="empty-tracks-message">
          <p>还没有轨道</p>
          <p>点击"添加轨道"创建第一个轨道</p>
        </div>
      )}
    </div>
  );
};

export default TrackList;